import React from "react";

import { FIELD_TYPE } from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";
import dayjs from "dayjs";
import { formatToCurrencyType } from "../../../../../helper/common";
import { APPROVE_STATUS } from "types/enums/employee";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER, CURRENCY } =
  FIELD_TYPE;
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const renderApproveStatus = (status: string) => {
  return APPROVE_STATUS[status] || "Không có trạng thái";
};
const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    dataIndex: "maNhanVien",
    width: 120,
    align: "left",
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 180,
    align: "left",
     fixed: "left",
    isResizable: true,
  },
  {
    title: "Loại hợp đồng",
    key: "loaiHopDong",
    show: true,
    dataIndex: "loaiHopDong",
    width: 200,
    align: "left",
    isResizable: true,
  },
  {
    title: "Chức vụ",
    key: "tenChucVu",
    show: true,
    dataIndex: "tenChucVu",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "TG BHXH",
    key: "thamGiaBHXH",
    show: true,
    dataIndex: "thamGiaBHXH",
    width: 80,
    align: "right",
    isResizable: true,
  },
  {
    title: "Tháng TG BHXH",
    key: "thangThamGiaBHXH",
    show: true,
    dataIndex: "thangThamGiaBHXH",
    width: 80,
    align: "right",
    isResizable: true,
  },

  {
    title: "Ngày vào công ty",
    key: "ngayVaoLam",
    show: true,
    dataIndex: "ngayVaoLam",
    width: 120,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => (v !== null ? dayjs(v).format("DD/MM/YYYY") : null),
  },
  {
    title: "Ngày sinh",
    key: "ngaySinh",
    show: true,
    dataIndex: "ngaySinh",
    width: 120,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => (v !== null ? dayjs(v).format("DD/MM/YYYY") : null),
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    show: true,
    dataIndex: "gioiTinh",
    width: 120,
    align: "center",
    isResizable: true,
  },
  {
    title: "Lương cơ bản",
    key: "luongCoBan",
    show: true,
    dataIndex: "luongCoBan",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "PC trách nhiệm công việc",
    key: "phuCapTrachNhiemCongViec",
    show: true,
    dataIndex: "phuCapTrachNhiemCongViec",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Hỗ trợ đi lại",
    key: "hoTroDiLai",
    show: true,
    dataIndex: "hoTroDiLai",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Hỗ trợ nhà ở",
    key: "hoTroNhaO",
    show: true,
    dataIndex: "hoTroNhaO",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng HQCV",
    key: "thuongHQCV",
    show: true,
    dataIndex: "thuongHQCV",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Cơm trưa",
    key: "comTrua",
    show: true,
    dataIndex: "comTrua",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Phụ cấp điện thoại",
    key: "dienThoai",
    show: true,
    dataIndex: "dienThoai",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Trang phục",
    key: "trangPhuc",
    show: true,
    dataIndex: "trangPhuc",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },

  {
    title: "Tổng mức thỏa thuận",
    key: "tongMucThoaThuan",
    show: true,
    dataIndex: "tongMucThoaThuan",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Ngày công đi làm",
    key: "congThuc",
    show: true,
    dataIndex: "congThuc",
    width: 120,
    align: "right",
    isResizable: true,
    // render(value, record, index) {
    //     return <>{formatToCurrencyType(value)}</>;
    // },
  },
  {
    title: "Công chuẩn tháng",
    key: "ngayCongChuan",
    show: true,
    dataIndex: "ngayCongChuan",
    width: 120,
    align: "right",
    isResizable: true,
  },
  {
    title: "Số giờ làm thêm ngày thường",
    key: "thuong150",
    show: true,
    dataIndex: "thuong150",
    width: 120,
    align: "right",
    isResizable: true,
    // render(value, record, index) {
    //     return <>{formatToCurrencyType(value)}</>;
    // },
  },
  {
    title: "Số giờ làm thêm ngày nghỉ ",
    key: "soNgayLamViecVaoNgayNghiHangTuan",
    show: true,
    dataIndex: "soNgayLamViecVaoNgayNghiHangTuan",
    width: 120,
    align: "right",
    isResizable: true,
    // render(value, record, index) {
    //     return <>{formatToCurrencyType(value)}</>;
    // },
  },
  {
    title: "Lương làm thêm ngày nghỉ",
    key: "soTienNhanLamThemChuNhatHangTuan",
    show: true,
    dataIndex: "soTienNhanLamThemChuNhatHangTuan",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  // {
  //     title: "Lễ, tết",
  //     key: "soNgayLamThemLeTet",
  //     show: true,
  //     dataIndex: " ",
  //     width: 120,
  //     align: "right",
  //     render(value, record, index) {
  //         return <>{formatToCurrencyType(value)}</>;
  //     },
  // },
  {
    title: "Lương làm thêm ngày thường",
    key: "thuong",
    show: true,
    dataIndex: "thuong",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Lương thời gian",
    key: "luongThoiGian",
    show: true,
    dataIndex: "luongThoiGian",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },

  // {
  //     title: "Lễ, tết thực trả ",
  //     key: "soTienNhanLamThemLeTet",
  //     show: true,
  //     dataIndex: "soTienNhanLamThemLeTet",
  //     width: 120,
  //     align: "right",
  //     render(value, record, index) {
  //         return <>{formatToCurrencyType(value)}</>;
  //     },
  // },
  {
    title: "Hỗ trợ nhà ở thực trả ",
    key: "hoTroNhaOThucTra",
    show: true,
    dataIndex: "hoTroNhaOThucTra",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Hỗ trợ đi lại thực trả ",
    key: "hoTroDiLaiThucTra",
    show: true,
    dataIndex: "hoTroDiLaiThucTra",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "PC trách nhiệm công việc thực trả",
    key: "pcTrachNhiemCongViecThucTra",
    show: true,
    dataIndex: "pcTrachNhiemCongViecThucTra",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Sinh nhật",
    key: "sinhNhat",
    show: true,
    dataIndex: "sinhNhat",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng PC chịu thuế",
    key: "tongPCChiuThue",
    show: true,
    dataIndex: "tongPCChiuThue",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng PC không chịu thuế",
    key: "tongPCKhongChiuThue",
    show: true,
    dataIndex: "tongPCKhongChiuThue",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },

  {
    title: "PC Cơm",
    key: "pcCom",
    show: true,
    dataIndex: "pcCom",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Điện thoại thực trả",
    key: "dienThoaiThucTra",
    show: true,
    dataIndex: "dienThoaiThucTra",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Trang phục thực trả",
    key: "trangPhucThucTra",
    show: true,
    dataIndex: "trangPhucThucTra",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng phụ cấp",
    key: "tongPhuCap",
    show: true,
    dataIndex: "tongPhuCap",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng Lễ",
    key: "thuongLe",
    show: true,
    dataIndex: "thuongLe",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng HQCV",
    key: "thuongHieuQuaCongViec",
    show: true,
    dataIndex: "thuongHieuQuaCongViec",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng chuyên cần",
    key: "thuongChuyenCan",
    show: true,
    dataIndex: "thuongChuyenCan",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng đột xuất ",
    key: "thuongDotXuat",
    show: true,
    dataIndex: "thuongDotXuat",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng hoa hồng",
    key: "thuongHoaHong",
    show: true,
    dataIndex: "thuongHoaHong",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng thưởng",
    key: "tongThuong",
    show: true,
    dataIndex: "tongThuong",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thưởng tháng lương thứ 13",
    key: "thuongLuongThang13",
    show: true,
    dataIndex: "thuongLuongThang13",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tiền lương ngừng việc",
    key: "tienLuongNgungViec",
    show: true,
    isResizable: true,
    dataIndex: "tienLuongNgungViec",
    width: 120,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Hỗ trợ tiền thuê nhà",
    key: "hoTroTienThueNha",
    show: true,
    dataIndex: "hoTroTienThueNha",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Hỗ trợ tiền đi lại",
    key: "hoTroTienDiLai",
    show: true,
    dataIndex: "hoTroTienDiLai",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Điều chỉnh lương tháng trước",
    key: "dieuChinhLuongThangTruoc",
    show: true,
    dataIndex: "dieuChinhLuongThangTruoc",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng thu nhập",
    key: "tongThuNhap",
    show: true,
    dataIndex: "tongThuNhap",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Lương BHXH",
    key: "luongBHXH",
    show: true,
    isResizable: true,
    dataIndex: "luongBHXH",
    width: 120,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHXH, BHYT (8%)",
    key: "bhxh_BHYT_8_PhanTram",
    show: true,
    dataIndex: "bhxh_BHYT_8_PhanTram",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHYT (1,5%)",
    key: "bhyt1PhayNamPhanTram",
    show: true,
    dataIndex: "bhyt1PhayNamPhanTram",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHTN (1%)",
    key: "bhtn_1_PhanTram",
    show: true,
    dataIndex: "bhtn_1_PhanTram",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Đoàn phí công đoàn",
    key: "doanPhiCongDoan",
    show: true,
    dataIndex: "doanPhiCongDoan",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Truy thu BH",
    key: "truyThuBH",
    show: true,
    dataIndex: "truyThuBH",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng thu BHXH của người LĐ",
    key: "tongThuBHXHCuaNguoiLaoDong",
    show: true,
    dataIndex: "tongThuBHXHCuaNguoiLaoDong",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng thu BHXH của người SDLĐ",
    key: "tongThuBHXHCuaNguoiSuDungLaoDong",
    show: true,
    dataIndex: "tongThuBHXHCuaNguoiSuDungLaoDong",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thu nhập chịu thuế",
    key: "thuNhapChiuThue",
    show: true,
    dataIndex: "thuNhapChiuThue",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Giảm trừ bản thân",
    key: "giamTruBanThan",
    show: true,
    dataIndex: "giamTruBanThan",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Số người phụ thuộc",
    key: "soNguoiPhuThuoc",
    show: true,
    dataIndex: "soNguoiPhuThuoc",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Giảm trừ NPT",
    key: "giamTruNPT",
    show: true,
    dataIndex: "giamTruNPT",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thu nhập Tính Thuế",
    key: "thuNhapTinhThue",
    show: true,
    dataIndex: "thuNhapTinhThue",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "TNCN phải nộp",
    key: "thuNhapCaNhanPhaiNop",
    show: true,
    dataIndex: "thuNhapCaNhanPhaiNop",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Trừ tạm ứng",
    key: "truTamUng",
    show: true,
    dataIndex: "truTamUng",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "TU_2% (Paid by employer)",
    key: "paidByEmployer",
    show: true,
    dataIndex: "paidByEmployer",
    width: 120,
    align: "right",
    isResizable: true,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thực Nhận",
    key: "thucNhan",
    show: true,
    dataIndex: "thucNhan",
    width: 120,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Lý do",
    key: "lyDo",
    show: true,
    dataIndex: "lyDo",
    width: 120,
    isResizable: true,
    align: "right",
  },
  {
    title: "Trạng thái",
    key: "trangThaiDuyet",
    show: true,
    dataIndex: "trangThaiDuyet",
    width: 100,
    isResizable: true,
    align: "right",
    fixed: "right",
    render(value, record, index) {
      return <>{renderApproveStatus(value)}</>;
    },
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "phong",
    disable: false,
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    options: listMonths,
    rules: [{ required: true, message: "Vui lòng chọn tháng" }],
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,
    options: listYears,
    rules: [{ required: true, message: "Vui lòng chọn năm" }],
  },
  {
    type: COMBO_BOX,
    name: "trangThaiDuyet",
    label: "Trạng thái duyệt",
    disable: false,
  },
];

export { allColumns, itemsInputField };
